import React from 'react'

export default function Coupon({ img, logo, content, subdomain, domain }) {
    const href = subdomain ? `https://${subdomain}.${domain}` : '#';
    return (
        <a href={href} className='coupon-card rounded-xl overflow-hidden relative'>
            <img src={img} alt="img" className='md:max-h-260 w-screen max-h-40 h-screen object-cover' width="260" height="260" loading="lazy" />
            <div className='whitebox absolute bottom-0 w-full h-14 overflow-hidden rounded-b-none'>
                <img src={logo} alt="logo" className='max-w-20 max-h-10' width="80" height="60" loading="lazy" />
                <p className='text-center md:hidden pb-4 mt-2.5 desc text-18 font-sans text-green leading-normal desc'>
                    {content}
                </p>
            </div>
        </a>
    )
}